import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Данная утилита генерирует код файл pubspec для подключения шрифтов в приложение Flutter", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Для начала работы выберите папку со шрифтами ttf, которые необходимо подключить.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  id: "butDirectory",
  autofocus: ""
}, "open directory", -1)
const _hoisted_4 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fonts, (font) => {
      return (_openBlock(), _createElementBlock("ul", null, [
        _createElementVNode("li", _hoisted_4, _toDisplayString(font.name), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(font.items, (item) => {
          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(item.name), 1))
        }), 256))
      ]))
    }), 256)),
    _createElementVNode("pre", null, _toDisplayString(_ctx.code), 1)
  ]))
}